/**
 * @file Table feature: columns sort.
 * @since 3.7.0
 */

import TableAbstractFeature from './TableAbstractFeature';

/**
 * Class representing Table Sort feature.
 */
export default class TableSort extends TableAbstractFeature {
  constructor(table) {
    super(table);

    this.listeners = {
      onTheadClick: (evt) => {
        if (evt.target.classList.contains('is-sortable')) {
          const clickedTh = evt.target;

          /*
           * Sorting only by single columns for now. In future should implement multi column sorting.
           * To insure backward compatibility `sortable: true` and `sortable: 'single'` should be the same.
           */
          this._singleSort(clickedTh.dataset.key, this._getSortDirection(clickedTh));
        }
      }
    };
  }

  init() {
    this._addEventListeners();
  }

  destroy() {
    this._removeEventListeners();
  }

  _addEventListeners() {
    this.component.dom.thead.addEventListener('click', this.listeners.onTheadClick);
  }

  _removeEventListeners() {
    this.component.dom.thead.removeEventListener('click', this.listeners.onTheadClick);
  }

  _getSortDirection(th) {
    switch(true) {
      case th.classList.contains('asc'):
        return 'desc';

      case th.classList.contains('desc'):
        // Use `return 'none';` here if you want to change order to: Asc -> Desc -> No sorting -> Asc -> etc.
        return 'asc';

      default:
        th.classList.add('asc');
        return 'asc';
    }
  }

  _singleSort(sortKey, sortDir) {
    Array.from(this.dom.thead.querySelectorAll('th.is-sortable')).forEach((th) => {
      if (th.dataset.key === sortKey) {
        switch(sortDir) {
          case 'asc':
            th.classList.remove('desc');
            th.classList.add('asc');
            break;

          case 'desc':
            th.classList.remove('asc');
            th.classList.add('desc');
            break;

          case 'none':
            th.classList.remove('asc');
            th.classList.remove('desc');
            break;
        }
      } else {
        // Remove sorting for all other columns
        th.classList.remove('asc');
        th.classList.remove('desc');
      }
    });

    this.component.onColumnSort(sortKey, sortDir);
  }

  _multiSort() {

  }

  /**
   * From observer Table.js
   */

  onCreatedHead() {
    // Add class to all sortable columns
    this.dom.thead.querySelectorAll('th').forEach((th) => {
      const column = this.component.settings.columns.find(col => col.key === th.dataset.key);
      if (column && column.sort) {
        th.classList.add('is-sortable');
        th.classList.toggle(column.sort, column.sort !== 'none');
      }
    });
  }

}
